<template>
    <admin-page-template :quick-access="false">
        <card-title
            v-if="currentStep === 1"
            title="Escolha o plano da sua hospedagem"
            no-header-decoration
            title-size="lg"
            class="px-md-2 pb-md-8 pt-md-2"
        >
            <steps-circle :steps="steps" :active-index="0" class="mb-8" />

            <div class="row justify-content-center">
                <div class="col-sm-6 col-xl-4">
                    <div class="card card-plan-group">
                        <div class="card-body">
                            <div class="mb-6">
                                <p class="h4 card-title text-center">Hospedagem PHP</p>
                                <p class="card-subtitle text-center text-uppercase">Ideal para sites e aplicações PHP</p>
                            </div>
                            <ul class="fa-ul mb-6">
                                <li><i class="fa-li fa fa-check"></i> Todas as versões PHP disponíveis</li>
                                <li><i class="fa-li fa fa-check"></i> Instalação de apps com um clique</li>
                                <li><i class="fa-li fa fa-check"></i> Acesso SSH, FTP e Gerenciador</li>
                                <li><i class="fa-li fa fa-check"></i> Banco de dados MySQL ou Postgres</li>
                            </ul>
                            <button
                                type="button"
                                class="btn btn-outline-success btn-block"
                                @click="goToStepTwo('app')"
                            >
                                Iniciar agora
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-xl-4">
                    <div class="card card-plan-group">
                        <div class="card-body">
                            <div class="mb-6">
                                <p class="h4 card-title text-center">Wordpress</p>
                                <p class="card-subtitle text-center text-uppercase">Site WordPress 5x mais rápido</p>
                            </div>
                            <ul class="fa-ul mb-6">
                                <li><i class="fa-li fa fa-check"></i> Automações para WordPress</li>
                                <li><i class="fa-li fa fa-check"></i> Plugin acelerador exclusivo</li>
                                <li><i class="fa-li fa fa-check"></i> Ambiente de teste para WordPress</li>
                                <li><i class="fa-li fa fa-check"></i> Gerenciamento de plugins</li>
                            </ul>
                            <button
                                type="button"
                                class="btn btn-outline-success btn-block"
                                @click="goToStepTwo('app')"
                            >
                                Iniciar agora
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </card-title
        >

        <card-title
            v-if="currentStep === 2"
            title="Configure os recursos da sua hospedagem"
            no-header-decoration
            title-size="lg"
            class="px-md-2 pb-md-8 pt-md-2"
        >
            <steps-circle :steps="steps" :active-index="1" class="mb-6" />

            <div class="row">
                <div class="col-md-8">
                    <div class="card card-plan mb-6">
                        <div class="card-header py-4">
                            <p class="h4 text-primary font-family-title font-weight-bold mb-0">
                                {{ currentPlan.name }}
                            </p>
                            <!--<p class="mb-0">
                                Quantidade de sites, desempenho  padrão, 100Gb de armazenamento SSD.
                                Pode modificar a quantidade de recursos disponíveis a qualquer momento.
                            </p>-->
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-9">
                                    <p class="text-xs text-muted text-uppercase font-weight-bold pl-1 mb-2">
                                        Recursos disponíveis
                                    </p>
                                    <div class="px-1">
                                        <slider-plan v-model="hosting.plan" mainColor="purple" :height="6" />
                                    </div>
                                </div>
                                <div class="col-3">
                                    <table class="table-borderless mt-2">
                                        <tr>
                                            <th class="pr-2 text-primary">RAM:</th>
                                            <td>{{ currentPlan.ram }}</td>
                                        </tr>
                                        <tr>
                                            <th class="pr-2 text-primary">CPU:</th>
                                            <td>{{ currentPlan.cpu }}</td>
                                        </tr>
                                        <tr>
                                            <th class="pr-2 text-primary">Disco:</th>
                                            <td>{{ currentPlan.disk }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="mb-6">
                        <p class="h4 font-weight-bold font-family-title text-primary mb-3">
                            Escolha a região do servidor
                        </p>

                        <div class="row">
                            <div class="col">
                                <div class="card card-region">
                                    <div class="card-body">
                                        <div class="d-flex justify-content-between">
                                            <div class="flex-grow-1">
                                                <p class="card-title h5 font-family-title font-weight-bold text-primary">
                                                    <img src="/images/BR.svg" class="icon" alt="" /> Brasil
                                                </p>
                                            </div>
                                            <div class="pl-3">
                                                <div class="btn-group-toggle" data-toggle="buttons">
                                                    <label class="btn btn-link p-0" v-bind:class="{ active: hosting.region === 'BR' }">
                                                        <span class="fa-stack icon-radio">
                                                            <i class="fa-circle fa-stack-2x" v-bind:class="[hosting.region === 'BR' ? 'fas' : 'far']"></i>
                                                            <i class="fas fa-circle fa-stack-1x fa-inverse"></i>
                                                        </span>
                                                        <input type="radio" value="BR" autocomplete="off" v-model="hosting.region">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <p class="small mb-0">
                                            Seu site <strong>até 5x mais rápido</strong> para visitantes no Brasil.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card card-region">
                                    <div class="card-body">
                                        <div class="d-flex justify-content-between">
                                            <div class="flex-grow-1">
                                                <p class="card-title h5 font-family-title font-weight-bold text-primary">
                                                    <img src="/images/US.svg" class="icon" alt="" /> E.U.A.
                                                </p>
                                            </div>
                                            <div class="pl-3">
                                                <div class="btn-group-toggle" data-toggle="buttons">
                                                    <label class="btn btn-link p-0" v-bind:class="{ active: hosting.region === 'US' }">
                                                        <span class="fa-stack icon-radio">
                                                            <i class="fa-circle fa-stack-2x" v-bind:class="[hosting.region === 'US' ? 'fas' : 'far']"></i>
                                                            <i class="fas fa-circle fa-stack-1x fa-inverse"></i>
                                                        </span>
                                                        <input type="radio" value="US" autocomplete="off" v-model="hosting.region">
                                                    </label>
                                                </div>
<!--                                                <span class="fa-stack icon-radio" @click.native="changeRegionUS">
                                                    <i class="fa-circle fa-stack-2x" v-bind:class="[this.hosting.region === 'US' ? 'fas' : 'far']"></i>
                                                    <i class="fas fa-circle fa-stack-1x fa-inverse"></i>
                                                </span>-->
                                            </div>
                                        </div>
                                        <p class="small mb-0">
                                            Velocidade padrão para visitantes no Brasil, porém <strong>mais barato</strong>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <p class="h4 font-weight-bold font-family-title text-primary mb-3">
                            Adicione recursos extras
                        </p>

                        <div class="card card-extra mb-4" v-bind:class="{ 'active': hosting.accelerator }">
                            <div class="card-body">
                                <div class="d-flex justify-content-between">
                                    <div class="flex-grow-1">
                                        <p class="card-title h5 font-family-title font-weight-bold text-primary">
                                            Acelerador de WordPress
                                        </p>
                                        <p class="mb-0">
                                            Diminua o tempo de carregamento das páginas e aumente a velocidade do seu
                                            site em até 57%.
                                        </p>
                                    </div>
                                    <div class="pl-3 text-right">
                                        <toggle-switch v-model="hosting.accelerator" />
                                        <div class="text-currency text-primary font-weight-semibold mt-3">
                                            <span class="currency">R$</span>
                                            <span class="amount">15,00</span>
                                            <span class="period">/mês</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card card-extra mb-4" v-bind:class="{ 'active': hosting.backup }">
                            <div class="card-body">
                                <div class="d-flex justify-content-between">
                                    <div class="flex-grow-1">
                                        <p class="card-title h5 font-family-title font-weight-bold text-primary">
                                            Backup Diário
                                        </p>
                                        <p class="mb-0">
                                            Garanta muito mais segurança para os dados do seu site com backups diários.
                                        </p>
                                    </div>
                                    <div class="pl-3 text-right">
                                        <toggle-switch v-model="hosting.backup" />
                                        <div class="text-currency text-primary font-weight-semibold mt-3">
                                            <span class="currency">R$</span>
                                            <span class="amount">10,00</span>
                                            <span class="period">/mês</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card card-extra mb-4" v-bind:class="{ 'active': hosting.migration }">
                            <div class="card-body">
                                <div class="d-flex justify-content-between">
                                    <div class="flex-grow-1">
                                        <p class="card-title h5 font-family-title font-weight-bold text-primary">
                                            Migração Prioritária
                                        </p>
                                        <p class="mb-0">
                                            Com a migração prioritária nossa equipe técnica iniciará a migração do seu
                                            site em até 12 horas.
                                        </p>
                                    </div>
                                    <div class="pl-3 text-right">
                                        <toggle-switch v-model="hosting.migration" />
                                        <div class="text-currency text-primary font-weight-semibold mt-3">
                                            <span class="currency">R$</span>
                                            <span class="amount">25,00</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="card card-summary mb-4">
                        <div class="card-body">
                            <purchase-summary
                                :plan-name="currentPlan.name"
                                :plan-price="currentPricing[longestPeriod]"
                                :old-price="currentPricing[1]"
                                :region="hosting.region"
                                :accelerator-price="acceleratorPrice"
                                :backup-price="backupPrice"
                                :migration-price="migrationPrice"
                                :accelerator="hosting.accelerator"
                                :backup="hosting.backup"
                                :migration="hosting.migration"
                            />
                        </div>
                    </div>

                    <div class="mb-2">
                        <button type="button" class="btn btn-success btn-block" @click="goToStepThree">Continuar</button>
                    </div>
                    <div>
                        <button type="button" class="btn btn-link btn-block" @click="backToStepOne">Voltar</button>
                    </div>
                </div>
            </div>

        </card-title>

        <card-title
            v-if="currentStep === 3"
            title="Adicione créditos e ganhe desconto"
            no-header-decoration
            title-size="lg"
            class="px-md-2 pb-md-8 pt-md-2"
        >
            <steps-circle :steps="steps" :active-index="2" class="mb-6" />

            <div class="row">
                <div class="col-md-8">
                    <div
                        v-for="period in cardOfferMonths"
                        :key="period"
                        class="card card-offer mb-4"
                        v-show="!isPaymentMode || currentPeriod === period"
                        v-bind:class="{ 'active': currentPeriod === period }"
                        @click="chooseBonus(period)"
                    >
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col-6">
                                    <div class="d-flex align-items-center">
                                        <span class="fa-stack icon-radio">
                                            <i class="fa-circle fa-stack-2x" v-bind:class="[currentPeriod === period ? 'fas' : 'far']"></i>
                                            <i class="fas fa-circle fa-stack-1x fa-inverse"></i>
                                        </span>
                                        <span class="offer-title">{{ period }} {{ period > 1 ? 'meses' : 'mês' }}</span>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <span v-if="period > 1" class="badge badge-sm badge-primary mb-0">
                                        Desconto de {{ calcDiscount(period) }}%
                                    </span>
                                    <span v-else class="badge badge-sm badge-secondary mb-0">
                                        Sem desconto
                                    </span>
                                </div>
                            </div>
                            <div class="mt-2">
                                <div class="row">
                                    <div class="col-6">
                                        <p class="text-sm text-secondary font-weight-semibold mb-0">
                                            Renovação aproximada em <span>{{ addMonths(period) }}</span>
                                        </p>
                                    </div>
                                    <div class="col-6">
                                        <div class="d-flex align-items-start">
                                            <del v-if="period > 1" class="d-inline-block text-muted text-sm font-weight-semibold mr-2">
                                                {{ currentPricing[1] | formatMoney }}
                                            </del>
                                            <div class="text-currency" v-bind:class="[period > 1 ? 'text-primary' : 'text-secondary']">
                                                <span class="currency">R$</span>
                                                <span class="amount">
                                                    {{ currentPricing[period] | formatMoney(2,"") }}
                                                </span>
                                                <span class="period">/mês</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="period === longestPeriod" class="card-footer">
                            Maior Desconto
                        </div>
                    </div>

                    <div v-if="!isPaymentSuccess" v-show="isPaymentMode" class="mb-4">
                        <button ref="btnChangePeriod" type="button" class="btn btn-outline-primary btn-block" @click="isPaymentMode = false">
                            <i class="far fa-calendar-alt pr-1"></i> Alterar período
                        </button>
                    </div>

                    <div v-if="!isPaymentSuccess" v-show="isPaymentMode">
                        <div class="card card-payment">
                            <div class="card-body">
                                <form accept-charset="UTF-8" @submit.prevent="finishPayment">
                                    <h5 class="font-weight-bold font-family-title mb-4">
                                        Forma de pagamento
                                    </h5>

                                    <div class="btn-group-payment btn-group-payment-method">
                                        <div class="btn-group-toggle" data-toggle="buttons">
                                            <label class="btn btn-outline-primary" v-bind:class="{ active: isPix }">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" class="icon">
                                                    <g transform="translate(-714 -542.746)">
                                                        <path d="M572.284,78.078a5.256,5.256,0,0,1-3.74-1.548l-5.4-5.4a1.026,1.026,0,0,0-1.419,0l-5.419,5.42a5.256,5.256,0,0,1-3.74,1.548H551.5l6.839,6.839a5.469,5.469,0,0,0,7.734,0l6.858-6.858Z" transform="translate(169.792 492.207)"/>
                                                        <path d="M552.568,34.995a5.256,5.256,0,0,1,3.74,1.548l5.419,5.42a1,1,0,0,0,1.419,0l5.4-5.4a5.256,5.256,0,0,1,3.74-1.548h.65l-6.858-6.858a5.469,5.469,0,0,0-7.735,0L551.5,34.995Z" transform="translate(169.791 516.191)"/>
                                                        <path d="M569.992,52.465l-4.144-4.144a.79.79,0,0,1-.294.059h-1.884a3.724,3.724,0,0,0-2.616,1.084l-5.4,5.4a2.595,2.595,0,0,1-3.665,0l-5.42-5.42a3.724,3.724,0,0,0-2.616-1.084h-2.317a.786.786,0,0,1-.278-.056L537.2,52.465a5.469,5.469,0,0,0,0,7.734l4.161,4.161a.787.787,0,0,1,.279-.056h2.317a3.724,3.724,0,0,0,2.616-1.084l5.419-5.419a2.654,2.654,0,0,1,3.666,0l5.4,5.4a3.724,3.724,0,0,0,2.616,1.084h1.884a.789.789,0,0,1,.294.059l4.144-4.144a5.469,5.469,0,0,0,0-7.734" transform="translate(178.406 504.414)"/>
                                                    </g>
                                                </svg>
                                                <input type="radio" value="PIX" autocomplete="off" v-model="formPaymentData.payment"> PIX
                                            </label>
                                            <label class="btn btn-outline-primary" v-bind:class="{ active: isCreditCard }">
                                                <i class="icon far fa-credit-card"></i>
                                                <input type="radio" value="CRD" autocomplete="off" v-model="formPaymentData.payment"> Cartão
                                            </label>
                                            <!--<label class="btn btn-outline-primary" v-bind:class="{ active: isMercadoPago }">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="36" viewBox="0 0 52 36" class="icon">
                                                    <g>
                                                        <path d="M25.984,36a39.055,39.055,0,0,1-10.733-1.412A26.365,26.365,0,0,1,7.06,30.735C2.507,27.456,0,22.939,0,18.015V17.006A12.055,12.055,0,0,1,2.04,10.4,18.721,18.721,0,0,1,7.605,4.989,33.855,33.855,0,0,1,25.984,0,33.93,33.93,0,0,1,44.391,4.989,18.718,18.718,0,0,1,49.96,10.4,12.051,12.051,0,0,1,52,17.006v1.009c0,4.933-2.5,9.45-7.029,12.719a26.263,26.263,0,0,1-8.2,3.853A39.38,39.38,0,0,1,25.984,36Zm.031-34.99A33.245,33.245,0,0,0,8.311,5.7C3.582,8.717.978,12.734.978,17.006s2.6,8.289,7.333,11.31A33.246,33.246,0,0,0,26.015,33c13.788,0,25.006-7.176,25.006-16S39.8,1.01,26.015,1.01Z"/>
                                                        <path d="M256.116,1283.924a2.05,2.05,0,0,1-2.052-1.956c0-.095,0-.316-.221-.316a.287.287,0,0,0-.253.126,1.415,1.415,0,0,1-.979.442,2.255,2.255,0,0,1-.663-.126,1.512,1.512,0,0,1-1.137-1.609.276.276,0,0,0-.032-.221l-.095-.063h-.063a.449.449,0,0,0-.189.063,1.61,1.61,0,0,1-.979.347,1.792,1.792,0,0,1-.568-.094,2.094,2.094,0,0,1-1.326-2.461.266.266,0,0,0-.063-.221l-.126-.095-.095.095a1.579,1.579,0,0,1-1.958.221,1.562,1.562,0,0,1-.631-1.862,1.579,1.579,0,0,1,1.642-1.073,1.609,1.609,0,0,1,1.421,1.388l.063.41.221-.347a2.2,2.2,0,0,1,2.557-.915,1.633,1.633,0,0,1,1.1,1.514c.032.19.158.19.19.19a.191.191,0,0,0,.189-.095,1.621,1.621,0,0,1,1.168-.473,2.118,2.118,0,0,1,.884.189c1.484.631.821,2.556.789,2.556-.126.316-.126.473,0,.536l.063.032h.031a1.12,1.12,0,0,0,.316-.063,1.714,1.714,0,0,1,.789-.189,2.035,2.035,0,0,1,0,4.07Zm15.818-9.15c-2.463-2.145-8.177-7.1-9.724-8.266a6.349,6.349,0,0,0-1.989-1.167,3.741,3.741,0,0,0-1.01-.158,3.271,3.271,0,0,0-1.231.221,10.022,10.022,0,0,0-2.968,1.862l-.063.031a7.842,7.842,0,0,1-2.526,1.609,4.28,4.28,0,0,1-.916.095,2.311,2.311,0,0,1-1.768-.568c-.031-.032,0-.126.095-.252l.031-.032,2.147-2.335c1.7-1.7,3.315-3.313,7.009-3.376h.189a13.039,13.039,0,0,1,4.862,1.136,14.653,14.653,0,0,0,6.63,1.578,17.18,17.18,0,0,0,7.262-1.735c-.284-.221-.568-.473-.884-.694a15.951,15.951,0,0,1-6.378,1.451,13.966,13.966,0,0,1-6.188-1.483,14.05,14.05,0,0,0-5.3-1.262h-.221a9.234,9.234,0,0,0-6.03,2.146,12.287,12.287,0,0,0-3,.568,8.057,8.057,0,0,1-2.115.379h-.821a42.526,42.526,0,0,1-7.609-2.114c-.316.221-.6.442-.916.663a37.663,37.663,0,0,0,8.272,2.4c.347,0,.695.063,1.074.063a10.369,10.369,0,0,0,2.4-.442c.442-.126.979-.284,1.484-.379l-.41.41-2.21,2.4a1.1,1.1,0,0,0-.316,1.2,1.526,1.526,0,0,0,.6.663,4.6,4.6,0,0,0,2.336.6,4.288,4.288,0,0,0,.916-.095,8.776,8.776,0,0,0,2.936-1.8,9.575,9.575,0,0,1,2.873-1.735,3.367,3.367,0,0,1,.789-.095h.221a4.286,4.286,0,0,1,2.147,1.041c1.831,1.357,9.819,8.361,9.914,8.424a1.525,1.525,0,0,1,.474,1.2,1.271,1.271,0,0,1-.632,1.01,1.762,1.762,0,0,1-1.042.316,1.929,1.929,0,0,1-.947-.252c-.032-.032-2.778-2.556-3.789-3.376a.707.707,0,0,0-.474-.252.225.225,0,0,0-.189.095c-.158.189,0,.473.221.631l3.22,3.218a1.806,1.806,0,0,1,.442.884,1.477,1.477,0,0,1-.789,1.325,2.32,2.32,0,0,1-1.137.378,1.646,1.646,0,0,1-.916-.284l-.442-.442c-.852-.852-1.7-1.7-2.336-2.24a.939.939,0,0,0-.473-.221.456.456,0,0,0-.221.063.354.354,0,0,0,.063.473c.063.063.095.126.158.189l2.336,2.619a.861.861,0,0,1,.063,1.1l-.095.126a1.369,1.369,0,0,1-.221.189,1.827,1.827,0,0,1-1.136.379,1.182,1.182,0,0,1-.316-.032.8.8,0,0,1-.442-.189l-.031-.031c-.126-.126-1.326-1.325-2.273-2.146a.867.867,0,0,0-.474-.252.342.342,0,0,0-.221.094c-.189.221.095.536.221.663l2.021,2.177a.435.435,0,0,1-.095.126c-.063.126-.316.347-1.042.442a.615.615,0,0,1-.253.032,4.726,4.726,0,0,1-1.958-.6,2.857,2.857,0,0,0-.189-2.84,2.9,2.9,0,0,0-2.494-1.388h-.126a2.667,2.667,0,0,0-1.484-2.808,3.468,3.468,0,0,0-1.263-.252,2.24,2.24,0,0,0-.916.158,2.348,2.348,0,0,0-1.452-1.231,3.079,3.079,0,0,0-1.073-.189,2.763,2.763,0,0,0-1.642.536,2.533,2.533,0,0,0-3.757-.221c-.6-.473-3.063-2.051-9.661-3.534-.347-.063-1.073-.284-1.515-.41-.063.347-.126.725-.158,1.073,0,0,1.2.284,1.452.347,6.725,1.483,8.967,3.061,9.345,3.345a2.5,2.5,0,0,0,2.778,3.439,2.881,2.881,0,0,0,1.894,2.208,2.241,2.241,0,0,0,.916.158,1.745,1.745,0,0,0,.568-.063,2.892,2.892,0,0,0,2.557,1.672,2.3,2.3,0,0,0,.789-.126,2.948,2.948,0,0,0,4.862.946,6.016,6.016,0,0,0,2.526.757c.126,0,.253-.031.379-.031a2.251,2.251,0,0,0,1.7-.852.315.315,0,0,0,.126-.158,3.436,3.436,0,0,0,.789.126,2.627,2.627,0,0,0,1.642-.6,2.274,2.274,0,0,0,.947-1.388,3.44,3.44,0,0,0,.568.031,3.239,3.239,0,0,0,1.673-.505,2.552,2.552,0,0,0,1.2-2.177,1.481,1.481,0,0,0,.537.063,2.809,2.809,0,0,0,1.579-.473,2.264,2.264,0,0,0,1.073-1.767,2.367,2.367,0,0,0-.347-1.451,67.125,67.125,0,0,1,10.387-3.25c-.031-.347-.063-.726-.126-1.073A60.833,60.833,0,0,0,271.934,1274.774Z" transform="translate(-232.026 -1256.095)"/>
                                                    </g>
                                                </svg>
                                                <input type="radio" value="MPA" autocomplete="off" v-model="formPaymentData.payment"> Mercado Pago
                                            </label>-->
                                        </div>
                                    </div>

                                    <div class="mb-8"></div>

                                    <div v-if="isCreditCard">
                                        <h5 class="font-weight-bold font-family-title mb-4">
                                            Dados do cartão de crédito
                                        </h5>

                                        <form-group label="Número do cartão" label-for="cardNumber" :error="formErrors.cardNumber">
                                            <the-mask
                                                type="tel"
                                                id="cardNumber"
                                                class="form-control form-control-lg"
                                                autocomplete="cc-number"
                                                placeholder="0000 0000 0000 0000"
                                                mask="#### #### #### ####"
                                                v-model="formPaymentData.cardNumber" />
                                        </form-group>

                                        <form-group label="Nome impresso no cartão" label-for="cardName" :error="formErrors.cardName">
                                            <input
                                                type="text"
                                                id="cardName"
                                                class="form-control"
                                                autocomplete="cc-name"
                                                v-model="formPaymentData.cardName"
                                                v-input-uppercase />
                                        </form-group>

                                        <div class="row">
                                            <div class="col-md-6">
                                                <form-group label="Validade" label-for="cardExpiration" :error="formErrors.cardExpiration">
                                                    <input
                                                        type="text"
                                                        id="cardExpiration"
                                                        class="form-control"
                                                        autocomplete="cc-exp"
                                                        placeholder="00/00"
                                                        v-mask="'##/##'"
                                                        v-model="formPaymentData.cardExpiration" />
                                                </form-group>
                                            </div>
                                            <div class="col-md-6">
                                                <form-group label="Código de segurança" label-for="cardCode" :error="formErrors.cardCode">
                                                    <the-mask
                                                        type="tel"
                                                        id="cardCode"
                                                        class="form-control"
                                                        autocomplete="cc-csc"
                                                        placeholder="000"
                                                        :mask="['###', '####']"
                                                        v-model="formPaymentData.cardCode" />
                                                </form-group>
                                            </div>
                                        </div>

                                        <div class="alert alert-primary mt-2 mb-8">
                                            <div class="d-flex align-items-center pt-1 mb-2">
                                                <toggle-switch v-model="formPaymentData.autoRecharge" />
                                                <p class="text-dark font-weight-semibold ml-3 mb-0">Ativar recarga automática</p>
                                            </div>
                                            <p class="text-sm text-secondary font-weight-semibold mb-0">
                                                Evite ficar com suas hospedagens suspensas usando a recarga automática.
                                                Será realizada uma cobrança automática no seu cartão quando seus
                                                créditos estiverem terminando.
                                            </p>
                                        </div>
                                    </div>

                                    <h5 class="font-weight-bold font-family-title mb-4">Dados de cobrança</h5>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <form-group v-if="!isMercadoPago" label="CPF / CNPJ" label-for="cpfCnpj" :error="formErrors.cpfCnpj">
                                                <the-mask
                                                    type="tel"
                                                    id="cpfCnpj"
                                                    class="form-control"
                                                    autocomplete="off"
                                                    :mask="['###.###.###-##', '##.###.###/####-##']"
                                                    v-model="formPaymentData.cpfCnpj" />
                                            </form-group>

                                            <form-group v-else label="CPF" label-for="cpf" :error="formErrors.cpf">
                                                <the-mask
                                                    type="tel"
                                                    id="cpf"
                                                    class="form-control"
                                                    autocomplete="off"
                                                    mask="###.###.###-##"
                                                    v-model="formPaymentData.cpf" />
                                            </form-group>
                                        </div>
                                    </div>

                                    <form-group :error="formErrors.name">
                                        <label class="form-label" for="name">
                                            {{ isCnpj ? 'Razão social' : 'Nome completo' }}
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            class="form-control"
                                            autocomplete="name"
                                            v-model="formPaymentData.name" />
                                    </form-group>

                                    <form-group label="E-mail" label-for="email" :error="formErrors.email">
                                        <input
                                            type="email"
                                            id="email"
                                            class="form-control"
                                            autocomplete="email"
                                            v-model="formPaymentData.email" />
                                    </form-group>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <form-group label="Telefone" label-for="phone" :error="formErrors.phone">
                                                <the-mask
                                                    type="tel"
                                                    id="phone"
                                                    class="form-control"
                                                    placeholder="(00) 00000-0000"
                                                    autocomplete="tel-national"
                                                    :mask="['(##) ####-####', '(##) #####-####']"
                                                    v-model="formPaymentData.phone" />
                                            </form-group>
                                        </div>
                                    </div>

                                    <div v-if="isCreditCard || isPix">
                                        <div class="pt-4"></div>

                                        <h5 class="font-weight-bold font-family-title mb-4">
                                            Endereço de cobrança
                                        </h5>

                                        <form-address
                                            zipcode-line
                                            v-model="formAdressData"
                                            :errors="formErrors" />
                                    </div>

                                    <form-group :error="formErrors.terms" class="mb-6">
                                        <checkbox-terms v-model="formPaymentData.terms" />
                                    </form-group>

                                    <button-form ref="btnPayment" type="submit" theme="success" class="btn-lg btn-block">
                                        Finalizar pagamento
                                    </button-form>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div v-if="isPaymentSuccess">
                        <div v-show="!isPaymentConfirmed && !isPaymentCancelled">
                            <div v-if="isPix">
                                <p>
                                    Utilize o aplicativo do seu banco para escanear o <strong>QR Code</strong> abaixo e
                                    concluir o pagamento.
                                </p>

                                <div class="mb-6">
                                    <p class="mb-1"><strong>Valor:</strong> {{ calcTotal() | formatMoney }}</p>
                                    <p class="mb-0"><strong>Expiração:</strong> {{ pixExpiration | moment("DD/MM/YYYY HH:mm:ss") }} (Horário de Brasília)</p>
                                </div>

                                <div class="mb-6">
                                    <img class="img-thumbnail d-block mx-auto" v-bind:src="pixQrCode" alt="">
                                </div>

                                <div class="form-inline justify-content-center mb-4">
                                    <label class="my-1 mr-2" for="pixCopyPaste">PIX Copia e Cola:</label>
                                    <input type="text" ref="pixCopyPaste" id="pixCopyPaste" class="form-control col-lg-6 my-1 mr-sm-2" readonly v-model="pixCode">
                                    <button type="button" class="btn btn-success my-1" @click="copyPixCode">Copiar</button>
                                </div>
                            </div>

                            <div v-if="isCreditCard" class="alert alert-success" role="alert">
                                Seu pagamento está sendo processado e você poderá ver os créditos em sua conta após a
                                aprovação. Este processo pode levar alguns minutos ou mais tempo a depender do status
                                do seu cartão de crédito.
                            </div>

                            <div class="alert alert-primary text-center" role="alert">
                                <i class="fas fa-circle-notch fa-spin mr-1"></i>
                                {{ isPix ? 'Verificando o pagamento do PIX...' : 'Verificando o seu pagamento...' }}
                            </div>
                        </div>

                        <div v-if="isPaymentConfirmed" class="alert alert-success text-center" role="alert">
                            <strong>O pagamento foi confirmado!</strong><br>
                            Agora clique no botão abaixo para continuar e criar a sua hospedagem.
                        </div>

                        <div v-if="isPaymentCancelled" class="alert alert-danger" role="alert">
                            O pagamento não pôde ser concluído. Clique no botão abaixo para tentar novamente.
                        </div>

                        <div class="form-buttons">
                            <button
                                type="button"
                                class="btn btn-lg btn-block btn-success"
                                :disabled="isPaymentCancelled"
                                v-show="!isPaymentCancelled"
                                @click="goToStepFour"
                            >
                                {{ isPaymentConfirmed ? 'Criar hospedagem' : 'Confirmar pagamento e continuar' }}
                            </button>

                            <button
                                type="button"
                                class="btn btn-lg btn-block btn-secondary"
                                v-if="isPaymentCancelled"
                                @click="backToStepThree"
                            >
                                Tentar novamente
                            </button>
                        </div>
                    </div>

                    <div class="mb-4 mb-md-0"></div>
                </div>

                <div class="col-md-4">
                    <div class="card card-summary mb-4">
                        <div class="card-body">
                            <purchase-summary
                                :plan-name="currentPlan.name"
                                :plan-price="currentPricing[currentPeriod]"
                                :old-price="currentPeriod > 1 ? currentPricing[1] : null"
                                :region="hosting.region"
                                :accelerator-price="acceleratorPrice"
                                :backup-price="backupPrice"
                                :migration-price="migrationPrice"
                                :accelerator="hosting.accelerator"
                                :backup="hosting.backup"
                                :migration="hosting.migration"
                                :subtotal-amount="currentPeriod > 1 ? calcTotal(true) : null"
                                :discount-amount="currentPeriod > 1 ? discountAmount : null"
                                :total-amount="calcTotal()"
                            />
                        </div>
                    </div>

                    <div v-if="!isPaymentSuccess" v-show="!isPaymentMode" class="mb-2">
                        <button type="button" class="btn btn-success btn-block" @click="enablePaymentMode">
                            {{ currentPeriod > 1 ? 'Garantir esta oferta!' : 'Concluir pagamento' }}
                        </button>
                    </div>
                    <div v-if="!isPaymentSuccess" v-show="!isPaymentMode" class="mb-2">
                        <button type="button" class="btn btn-outline-secondary btn-block" @click="goToStepFour">
                            Não quero desconto
                        </button>
                    </div>
                    <div v-if="!isPaymentSuccess">
                        <button ref="btnCheckoutBack" type="button" class="btn btn-link btn-block" @click="backToStepTwo">
                            Voltar
                        </button>
                    </div>
                </div>
            </div>
        </card-title>

        <card-title
            v-if="currentStep === 4"
            title="Escolha um domínio para sua hospedagem"
            no-header-decoration
            title-size="lg"
            class="px-md-2 pb-md-8 pt-md-2"
        >
            <steps-circle :steps="steps" :active-index="3" class="mb-6" />

            <p>
                Para concluir a criação de sua hospedagem, escolha o domínio que será utilizado.
                O domínio é o endereço do seu site ou aplicação na internet.
            </p>

            <form-domain-check :loading="isCreatingHosting" />

            <div v-if="!isPaymentSuccess" class="text-center mt-4">
                <button ref="btnCreateHostingBack" type="button" class="btn btn-link" @click="backToStepThree">Voltar</button>
            </div>
        </card-title>
    </admin-page-template>
</template>

<script>
    import VueSlider         from 'vue-slider-component'
    import {mapActions, mapState} from 'vuex'
    import creditCard        from "@/mixins/creditCard";
    import payment           from "@/mixins/payment";
    import ErrorService      from "@/services/error.service";
    import ButtonForm        from "@/components/atoms/ButtonForm";
    import CheckboxTerms     from "@/components/atoms/CheckboxTerms";
    import StepsCircle       from '@/components/atoms/StepsCircle'
    import SliderPlan        from '@/components/atoms/SliderPlan'
    import ToggleSwitch      from '@/components/atoms/ToggleSwitch'
    import ZipCode           from "@/components/atoms/ZipCode";
    import CardTitle         from '@/components/molecules/CardTitle'
    import FormDomainCheck   from '@/components/molecules/FormDomainCheck'
    import FormGroup         from "@/components/molecules/FormGroup";
    import PurchaseSummary   from '@/components/molecules/PurchaseSummary'
    import FormAddress       from "@/components/organisms/FormAddress";
    import AdminPageTemplate from '@/components/templates/AdminPageTemplate'

    export default {
        mixins: [
            creditCard,
            payment,
        ],
        components: {
            ButtonForm,
            CheckboxTerms,
            FormAddress,
            ZipCode,
            FormGroup,
            PurchaseSummary,
            ToggleSwitch,
            VueSlider,
            FormDomainCheck,
            StepsCircle,
            SliderPlan,
            CardTitle,
            AdminPageTemplate
        },
        data() {
            return {
                steps: [
                    'Plano',
                    'Recursos',
                    'Checkout',
                    'Domínio'
                ],
                planGroups: {
                    'wordpress' : [],
                    'app'       : [],
                },
                pricing: null,
                bonusPercents: {
                    1  : 0,
                    6  : 5,
                    12 : 10,
                    24 : 20,
                    36 : 30,
                },
                longestPeriod: 36,
                cardOfferMonths: [36, 24, 12, 6, 1],

                acceleratorPrice: 15,
                backupPrice: 10,
                migrationPrice: 25,

                currentStep: 1,
                currentPlan: {},
                currentPeriod: this.longestPeriod,
                isPaymentMode: false,

                planGroup: "",
                hosting: {
                    plan: 1,
                    region: "BR",
                    accelerator: false,
                    backup: false,
                    migration: false,
                    bonus: 1,
                },

                formPaymentData: {
                    payment: "PIX",
                    autoRecharge: false,
                },
                formAdressData: {},
                formErrors: {},

                // Google
                googleClientId: null,
                googleSessionId: null,

                invoiceId: null,
                isPaymentSuccess: false,
                isPaymentConfirmed: false,
                isPaymentCancelled: false,
                isCreatingHosting: false,
                hasCreatedHosting: false,

                // Pix
                pixQrCode: "",
                pixCode: "",
                pixExpiration: "",
            }
        },
        computed: {
            ...mapState('user', ['user']),

            isRegionUs: function() {
                return this.hosting.region === "US";
            },
            isRegionBr: function() {
                return this.hosting.region === "BR";
            },
            currentPricing: function() {
                return this.pricing ? this.pricing[this.hosting.region][this.currentPlan.id] : null;
            },
            monthlyPrice: function()
            {
                let total = 0;

                if (this.currentPlan.price) {
                    total += this.currentPlan.price[this.hosting.region];
                }
                if (this.hosting.accelerator) {
                    total += this.acceleratorPrice;
                }
                if (this.hosting.backup) {
                    total += this.backupPrice;
                }

                return total;
            },
            totalMonthly: function ()
            {
                let total = 0;

                if (this.currentPricing) {
                    total += this.currentPricing[this.currentPeriod] * this.currentPeriod;
                }
                if (this.hosting.accelerator) {
                    total += this.acceleratorPrice * this.currentPeriod;
                }
                if (this.hosting.backup) {
                    total += this.backupPrice * this.currentPeriod;
                }

                return total;
            },
            totalAmount: function()
            {
                let total = this.totalMonthly;

                if (this.hosting.migration) {
                    total += this.migrationPrice;
                }

                return total;
            },
            bonusAmount: function() {
                return this.totalMonthly ? this.totalMonthly * (this.bonusPercents[this.currentPeriod] / 100) : 0;
            },
            discountAmount: function ()
            {
                return this.currentPricing
                    ? (this.currentPricing[1] - this.currentPricing[this.currentPeriod]) * this.currentPeriod
                    : 0;
            },
            isCnpj: function() {
                return (!this.isMercadoPago && this.formPaymentData.cpfCnpj) ? this.formPaymentData.cpfCnpj.length > 11 : false;
            },
            isCreditCard: function () {
                return this.formPaymentData.payment === 'CRD';
            },
            isPix: function () {
                return this.formPaymentData.payment === 'PIX';
            },
            isMercadoPago: function () {
                return this.formPaymentData.payment === 'MPA';
            },
        },
        beforeRouteLeave (to, from, next)
        {
            if (!this.hasCreatedHosting && this.currentStep > 1 && this.confirmStayInPage()) {
                next(false)
            }
            else {
                next();
                document.querySelector(".h-o-admin-header").classList.remove("d-none");
                document.querySelector(".h-o-announcement-area").classList.remove("d-none");
                document.querySelector(".h-m-nav-help .btn-group-tutorial").classList.remove("d-none");
                document.querySelector(".h-m-nav-help .btn-help").classList.remove("d-none");
            }
        },
        created()
        {
            window.addEventListener("beforeunload", this.beforeWindowUnload)

            // Events for credit card payment
            this.$eventBus.$on('cc-fingerprint-error', () => {
                this.$refs.btnPayment.setLoading(false);
                this.$refs.btnPayment.setDisabled(true);
                this.$refs.btnPayment.$el.innerHTML = 'Indisponível no momento';
            });

            this.$eventBus.$on('cc-fingerprint-ready', () => {
                this.$refs.btnPayment.setLoading(false);
            });

            this.$eventBus.$on('cc-script-loaded', () => {
                this.$refs.btnPayment.setLoading(false);
            });

            this.$eventBus.$on('cc-script-error', () => {
                this.$refs.btnPayment.setLoading(false);
            });

            // Events for hosting creation
            this.$eventBus.$on('hosting-create-domain-chosen', this.createHosting)

            // GA4 identifiers
            if (typeof window.gtag !== 'undefined' && typeof window.GA4_MEASUREMENT_ID !== 'undefined')
            {
                gtag('get', window.GA4_MEASUREMENT_ID, 'client_id', (clientID) => {
                    this.googleClientId = clientID;
                });

                gtag('get', window.GA4_MEASUREMENT_ID, 'session_id', (sessionID) => {
                    this.googleSessionId = sessionID;
                });
            }

            this.getPlans();
            this.getPricing();
        },
        mounted()
        {
            const createHostingViewed = sessionStorage.getItem('create_hosting_viewed');

            if (this.user && this.user.isFirstAccess && createHostingViewed != 1) {
                sessionStorage.setItem('create_hosting_viewed', 1);
                document.querySelector(".h-o-admin-header").classList.add("d-none");
                document.querySelector(".h-o-announcement-area").classList.add("d-none");
                document.querySelector(".h-m-nav-help .btn-group-tutorial").classList.add("d-none");
                document.querySelector(".h-m-nav-help .btn-help").classList.add("d-none");
            }
        },
        beforeDestroy()
        {
            window.removeEventListener("beforeunload", this.beforeWindowUnload);
        },
        methods: {
            ...mapActions({
                showErrorAlert: 'alert/error',
            }),

            getPlans()
            {
                this.$api.get('/hosting/plans')
                    .then(response => {
                        this.planGroups.wordpress = response.data.data;
                        this.currentPlan = this.planGroups.wordpress[this.hosting.plan];
                    })
                    .catch(error => this.showErrorAlert("Ocorreu um erro ao carregar os planos disponíveis."));
            },

            getPricing()
            {
                this.$api.get('/hosting/pricing')
                    .then(response => {
                        this.pricing = response.data.data;

                        const keys = Object.keys(this.pricing['US'][1]);
                        const periods = keys.map(value => parseInt(value));
                        this.longestPeriod = Math.max(...periods);
                        this.currentPeriod = this.longestPeriod;
                        this.cardOfferMonths = periods.sort((a,b) => b-a);
                    })
                    .catch(error => this.showErrorAlert("Ocorreu um erro ao carregar os preços dos planos disponíveis."));
            },

            goToStepTwo(plan)
            {
                this.planGroup = plan;
                this.hosting.plan = 1;
                this.currentStep = 2;
            },

            goToStepThree()
            {
                this.currentStep = 3;
            },

            goToStepFour(disableGoBack)
            {
                this.isPaymentConfirmed = true;
                this.currentStep = 4;
            },

            backToStepOne()
            {
                this.planGroup           = "";
                this.hosting.plan        = 1;
                this.hosting.region      = "BR";
                this.hosting.accelerator = false;
                this.hosting.backup      = false;
                this.hosting.migration   = false;
                this.currentStep         = 1;
                this._resetPayment();
            },

            backToStepTwo()
            {
                this.hosting.bonus = 1;
                this.currentStep   = 2;
                this._resetPayment();
            },

            backToStepThree()
            {
                this.currentStep = 3;
                this._resetPayment();
            },

            _resetPayment()
            {
                this.isPaymentMode      = false;
                this.isPaymentSuccess   = false;
                this.isPaymentConfirmed = false;
                this.isPaymentCancelled = false;
                this.currentPeriod      = this.longestPeriod;
            },

            chooseBonus(period)
            {
                this.currentPeriod = period;
                this.hosting.bonus = period;
            },

            calcBonus(months)
            {
                return this.monthlyPrice ? this.monthlyPrice * months * (this.bonusPercents[months] / 100) : 0;
            },

            calcDiscount(months)
            {
                return this.currentPricing
                    ? Math.floor(100 * ((this.currentPricing[1] - this.currentPricing[months]) / this.currentPricing[1]))
                    : 0;
            },

            calcTotal(noDiscount)
            {
                let total = 0;
                const pricingPeriod = typeof noDiscount !== "undefined" && !!noDiscount ? 1 : this.currentPeriod;

                if (this.currentPricing) {
                    total += this.currentPricing[pricingPeriod] * this.currentPeriod;
                }
                if (this.hosting.accelerator) {
                    total += this.acceleratorPrice * this.currentPeriod;
                }
                if (this.hosting.backup) {
                    total += this.backupPrice * this.currentPeriod;
                }

                return total;
            },

            addMonths(months)
            {
                let now = new Date();
                now.setDate(now.getDate() + (months * 30));

                return this.$moment(now).format('DD/MM/YYYY');
            },

            updateAddress(data)
            {
                if (data)
                {
                    this.$set(this.formPaymentData, 'addressStreet',       data.street);
                    this.$set(this.formPaymentData, 'addressComplement',   data.complement);
                    this.$set(this.formPaymentData, 'addressNeighborhood', data.neighborhood);
                    this.$set(this.formPaymentData, 'addressCity',         data.city);
                    this.$set(this.formPaymentData, 'addressState',        data.state);
                    this.disableCityStateFields = true;
                }
                else
                {
                    this.$set(this.formPaymentData, 'addressCity',  '');
                    this.$set(this.formPaymentData, 'addressState', '');
                    this.disableCityStateFields = false;
                }
            },

            enablePaymentMode()
            {
                this.isPaymentMode = true;

                // Init credit card payment
                this.$refs.btnPayment.setLoading(true);
                this.initCreditCard();
            },

            finishPayment()
            {
                this.formErrors = {};
                this.formPaymentData.googleClientId  = this.googleClientId;
                this.formPaymentData.googleSessionId = this.googleSessionId;

                this.$refs.btnChangePeriod.disabled = true;
                this.$refs.btnCheckoutBack.disabled = true;
                this.$refs.btnPayment.loadingFocus();

                let postData = Object.assign({}, this.formPaymentData, this.formAdressData);

                // Amount
                postData.amount = this.calcTotal();
                postData.period = this.currentPeriod;

                // Product
                postData.plan   = this.currentPlan.id;
                postData.region = this.hosting.region;

                if (this.isCreditCard)
                {
                    // Browser fingerprint
                    postData.fingerprint = this.ccFingerprint;

                    this.$api.post('/recharge/validate-card', postData)
                        .then(response => {
                            return this.$api.post('/recharge', postData);
                        })
                        .then((response) => {
                            this.invoiceId = response.data.data.invoice;
                            this.isPaymentSuccess = true;
                            this.trackPurchase("credit-card", postData.amount);
                            this.checkPayment();
                        })
                        .catch(error => {
                            ErrorService.handleFormError(error, this);
                            this.$refs.btnPayment.setLoading(false);
                            this.$refs.btnChangePeriod.disabled = false;
                            this.$refs.btnCheckoutBack.disabled = false;
                        });
                }
                else
                {
                    this.$api.post('/recharge', postData)
                        .then(response => {
                            if (this.isPix)
                            {
                                this.pixCode = response.data.data.code;
                                this.pixQrCode = response.data.data.qrcode;
                                this.pixExpiration = response.data.data.expiration;
                                this.trackPurchase("pix", postData.amount);
                            }

                            this.invoiceId = response.data.data.invoice;
                            this.isPaymentSuccess = true;
                            this.checkPayment();
                        })
                        .catch(error => {
                            ErrorService.handleFormError(error, this);
                            this.$refs.btnPayment.setLoading(false);
                            this.$refs.btnChangePeriod.disabled = false;
                            this.$refs.btnCheckoutBack.disabled = false;
                        });
                }
            },

            checkPayment()
            {
                if (this.currentStep != 3) return;

                this.$api.get(`/recharge/status/${this.invoiceId}`)
                    .then((response) => {
                        const paymentStatus = response.data.data.status;

                        if (paymentStatus === "Paid") {
                            this.isPaymentConfirmed = true;
                            this.$eventBus.$emit("credits-recharged");
                        }
                        else if (paymentStatus === "Cancelled") {
                            this.isPaymentCancelled = true;
                        }
                        else {
                            setTimeout(this.checkPayment, 5000);
                        }
                    })
                    .catch(() => {
                        setTimeout(this.checkPayment, 10000);
                    });
            },

            copyPixCode()
            {
                this.$refs.pixCopyPaste.select();
                document.execCommand('copy');
            },

            createHosting(data)
            {
                this.isCreatingHosting = true;
                this.$refs.btnCreateHostingBack && (this.$refs.btnCreateHostingBack.disabled = true);
                this.formErrors = {};

                const postData = {
                    domain      : data.domain,
                    plan        : this.currentPlan.id,
                    region      : this.hosting.region,
                    accelerator : this.hosting.accelerator,
                    dailyBackup : this.hosting.backup,
                    migration   : this.hosting.migration,
                };

                this.$api.post('/hosting', postData)
                    .then(response => {
                        const domain = response.data.data.domain;
                        this.hasCreatedHosting = true;
                        this.$router.push("/hosting/" + domain + (this.hosting.migration ? "?migration=1" : ""));
                        this.$eventBus.$emit('hosting-created', { domain: domain });
                    })
                    .catch(error => {
                        this.showErrorAlert(error);
                        this.isCreatingHosting = false;
                        this.$refs.btnCreateHostingBack && (this.$refs.btnCreateHostingBack.disabled = false);
                    });
            },

            confirmStayInPage() {
                return !confirm('Você ainda não finalizou a criação de sua hospedagem! Tem certeza que deseja sair desta página?');
            },

            beforeWindowUnload(e)
            {
                if (this.currentStep > 1 && this.confirmStayInPage()) {
                    e.preventDefault();
                    e.returnValue = false;
                }
            },
        },
        watch: {
            "hosting.plan": function (val) {
                this.currentPlan = this.planGroups.wordpress[val];
            }
        }
    }
</script>

<style lang="stylus">
    .card-plan-group {
        .card-title {
            font-family $font-family-title
            font-weight 700
            color $primary
        }
        .card-subtitle {
            font-size .75rem
            font-weight 800
            color $gray-700
        }
        ul > li {
            margin-bottom 6px
            font-size .875rem
            font-weight 500

            &:last-child {
                margin-bottom 0
            }
        }
        .fa-ul {
            .fa-li {
                color $purple-light
            }
        }
        .btn {
            border-width: 2px;
            padding-top .375rem
            padding-bottom .375rem
            font-weight 600
        }
    }

    .card-plan {
        .card-header {
            background-color rgba($purple-light, 15%)
            border-bottom 0
        }
    }

    .card-region {
        .card-title {
            display flex
            flex-direction row
            align-items center

            img {
                width 2.25rem
                margin-right 8px
            }
        }
    }

    .card-extra {
        &.active {
            background-color rgba($purple-light, 15%)
        }
    }

    .card-summary {
        .plan-name {
            color $gray-700

            img {
                display inline-block
                vertical-align top
                width 1.5rem
                margin-left 4px
            }
        }
        .fa-ul {
            margin-left: 1.5em;
        }
        ul > li {
            margin-bottom 6px
            font-size: 1rem;
            font-weight: 500;
            color $gray-600

            &:last-child {
                margin-bottom 0
            }
        }
    }

    .card-offer {
        cursor: pointer;

        &.active {
            border-color $purple
            background-color rgba($purple-light, 15%)
        }
        &.no-offer.active {
            border-color $gray-700
            background-color $gray-200

            .icon-radio .fa-stack-2x {
                color $gray-700
            }
        }
        .icon-radio {
            margin-right 4px
            font-size .875rem

            .fa-stack-2x {
                color $purple
            }
        }
        .offer-title {
            font-size 1.25rem
            font-weight bold
            color $gray-600
        }
        .card-footer {
            border-top 0
            padding-top 0.25rem
            padding-bottom 0.25rem
            text-align center
            font-size .75rem
            font-weight 800
            text-transform uppercase
            letter-spacing .05em
            background-color $purple-light
            color white
        }
        .text-currency {
            font-size 1.75rem
            font-weight 700
            line-height 1

            .currency {
                font-weight inherit
                font-size .5em
            }
            .period {
                font-size .5em
            }
        }
    }

    .text-currency {
        display flex
        flex-direction row
        align-items: center;

        .currency {
            font-size .625em
            font-weight 800
            margin-right 3px
        }
        .period {
            font-size .75em
            margin-left 1px
        }
        .fa-plus {
            font-size .5em
        }
    }
</style>
